import React from 'react';
import ThemeToggle from '../ui/ThemeToggle';
import VolumeToggle from '../ui/VolumeToggle';

export default function Header({ isDark, onToggle, playing, onTogglePlay }) {
  return (
    <header className='navbar'>
        <ul className='navbar__list'>
        <li className='navbar__list-item navbar__list-item--left'>
          <VolumeToggle playing={playing} onTogglePlay={onTogglePlay} />
        </li>
        <li className='navbar__list-item navbar__list-item--middle'></li>
        <li className='navbar__list-item navbar__list-item--right'>
          <ThemeToggle isDark={isDark} onToggle={onToggle} />
        </li>
        </ul>
    </header>
  )
}
